import { Injectable } from '@angular/core'
import { isNullOrUndefined } from '@gofive/angular-common'
import { map } from 'rxjs'
import {
	AddonPlanDescType,
	AddonPlanGroup,
	AddonPlanGroupName,
	AddonPlanUnitType,
	fileModel,
} from 'src/domain/models/addon-type'
import { DataTableModel } from 'src/domain/models/datatable.model'
import { AddonTypeModel, PlanTypeModel } from 'src/domain/models/plan.model'
import { PlanRepository } from 'src/domain/repositories/plan.repository'
import { DefaultResultDataSource } from '../entities/base.entity'
import { PlanDataTableTypeEntity, PlanTypeEntity } from '../entities/plan.entity'
import { PlanAddonMapper } from '../mappers/plan/plan-addon.mapper'
import { PlanDataTableMapper } from '../mappers/plan/plan-data-table.mapper'

@Injectable({
	providedIn: 'root',
})
export class PlanImplementationRepository extends PlanRepository {
	planDataTableMapper = new PlanDataTableMapper()
	planAddonMapper = new PlanAddonMapper()

	GetPlanAsync(params: { id: number }) {
		return this.get<any>('api/Plans/' + params.id) // did not mapped yet since this endpoint not really used
	}

	AddEditPlan(params: { model: PlanTypeModel }) {
		if (params.model.planId > 0) {
			return this.put<string>('api/Plans/' + params.model.planId, params.model)
		} else {
			return this.post<string>('api/Plans', params.model)
		}
	}

	AddEditAddon(params: { model: AddonTypeModel }) {
		if (params.model.planId > 0 && params.model.planId) {
			return this.put<string>(`api/plans/add-on/${params.model.planId}`, params.model)
		} else {
			return this.post<string>(`api/plans/add-on/${params.model.productId}`, params.model)
		}
	}

	AddEditAddonPlanGroup(params: { model: AddonPlanGroup; productId?: number }) {
		if (params.productId === 0) {
			return this.put<any>('api/PlanGroups/add-on', params.model) // skipcq: JS-0323
		} else {
			return this.post<any>(`api/PlanGroups/add-on/${params.productId}`, params.model) // skipcq: JS-0323
		}
	}

	AddAddonlogo(params: { model: fileModel }) {
		return this.post<fileModel>('api/plans/logo-upload', params.model)
	}

	GetAddonGroup(params: { productId: number }) {
		return this.get<AddonPlanGroupName>(`api/planGroups/add-ons/${params.productId}`)
	}

	GetAddonPlanGroup(params: { planGroupId: number }) {
		return this.get<AddonPlanGroup>(`api/PlanGroups/${params.planGroupId}`)
	}

	GetAddonDetail(params: { planId: number }) {
		return this.get<AddonTypeModel>(`api/plans/add-on/${params.planId}`)
	}

	GetAddonUnitType() {
		return this.get<AddonPlanUnitType>('api/plans/unit-type')
	}

	GetAddonDescType() {
		return this.get<AddonPlanDescType>('api/plans/desc-type')
	}

	EditPlan(params: { model: PlanTypeModel }) {
		return this.put<string>('api/Plans/' + params.model.planId, params.model)
	}

	GetDataTablePlans(params: {
		model: DataTableModel
		preCondition: Object
		param?: Array<string>
		search?: string
		filter?: Object
	}) {
		let whereCause: string
		if (params.filter && Object.values(params.filter).filter((x) => !isNullOrUndefined(x)).length > 0) {
			whereCause = this.createWhereCause(params.preCondition, params.param, params.search, params.filter)
		} else if (!isNullOrUndefined(params.search)) {
			whereCause = this.createWhereCause(params.preCondition, params.param, params.search)
		} else {
			whereCause = this.createWhereCause(params.preCondition)
		}
		params.model.whereCause = whereCause
		if (params.model.orderBy === null) {
			params.model.orderBy = 'PlanId'
		}
		return this.post<DefaultResultDataSource<PlanDataTableTypeEntity[]>>('api/Plans/DataTable', params.model).pipe(
			map((response) => {
				return response.dataSource.map((item) => {
					return this.planDataTableMapper.mapFrom(item)
				})
			}),
		)
	}

	GetAddonByPlan(params: {
		model: DataTableModel
		preCondition: Object
		param?: Array<string>
		search?: string
		filter?: Object
	}) {
		let whereCause: string
		if (params.filter && Object.values(params.filter).filter((x) => !isNullOrUndefined(x)).length > 0) {
			whereCause = this.createWhereCause(params.preCondition, params.param, params.search, params.filter)
		} else if (!isNullOrUndefined(params.search)) {
			whereCause = this.createWhereCause(params.preCondition, params.param, params.search)
		} else {
			whereCause = this.createWhereCause(params.preCondition)
		}
		params.model.search = params.search
		params.model.whereCause = whereCause
		if (params.model.orderBy === null) {
			params.model.orderBy = 'PlanId'
		}
		return this.post<DefaultResultDataSource<PlanTypeEntity[]>>('api/Plans/GetAddonByPlanId', params.model).pipe(
			map((response) => {
				return response.dataSource.map((item) => {
					return this.planAddonMapper.mapFrom(item)
				})
			}),
		)
	}
}
